<template>

  <div class="register-container">
    <div class="row">
      <div class="col-md-12">
        <div class="text-center m-b-md">
        </div>
        <div class="hpanel">
          <div class="panel-body">
            <div v-if="token">
              <div>
                <div class="text-center">
                  <h4>Email Confirmation</h4>
                </div>
                <div class="progress full m-t-xs" style="margin: 40px 0">
                  <div class="progress-bar progress-bar-striped active progress-bar-info" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%">
                  </div>
                </div>
                <div style="margin-top: 15px;text-align: center">
                  <div v-if="isVerify === true">
                    <h5>Congratulation your email has been verified</h5>
                    <h5>You will be redirected to your account</h5>
                  </div>
                  <div v-else-if="isVerify === false">
                    <h5>your token has already been used</h5>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div>
                <div class="text-center">
                  <h4>{{ $t('signUp.userCreated.title') }}</h4>
                  <h5>{{ $t('signUp.userCreated.sub_title') }}</h5>
                </div>

                <div style="margin-top: 15px">
                  <h5>{{ $t('signUp.userCreated.info', {email: email}) }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!token" style="position: relative;margin-bottom: 15px">
          <img :src="$apiUrl + '/img/art-materials.jpg'" style="width: 100%">

          <div style="width:100%;position: absolute;top: 70px" class="text-center">
            <div class="font-bold" style="font-size: 16px">Welcome to the Open Innovation platform</div>
            <div class="text-left" style="display: inline-block">

              <ul style="list-style: inside;margin-top: 15px">
                <li>Find and organize knowledge</li>
                <li>Identify experts and ecosystems</li>
                <li>Share and connect</li>
              </ul>
            </div>
          </div>

          <div class="text-center" style="padding: 15px">
            <template v-if="!newActivationLinkAsked">
              <a @click="newActivationLink">I can no longer find my activation link</a>
            </template>
            <template v-else>
              <div class="text-center text-success">
                An email has been sent with the new activation code
              </div>
            </template>
          </div>

        </div>

        <div v-else-if="token && isVerify === true" style="margin-bottom: 15px" class="text-center">
          <h4>Get started with Open Innovation !</h4>
          <img :src="$apiUrl + '/img/bright-energy-innovation.jpg'" style="width: 100%">
        </div>

      </div>
    </div>
    <div class="row">
      <div class="col-md-12 text-center">
        <strong><a href="https://www.idexlab.com" target="_blank"> IDEXLAB</a></strong><br/> {{year}} Copyright Idexlab
      </div>
    </div>
  </div>
</template>

<script>
import VueCookies from 'vue-cookies'
export default {
  components: {
  },
  name: 'EnableAccount',
  props: ['email', 'enableAccount'],
  methods: {
    newActivationLink (event) {
      event.preventDefault()

      this.axios.post('auth/newActivationLink', {email: this.email})
        .then(() => {
          this.newActivationLinkAsked = true

          setTimeout(() => {
            location.reload()
          }, 5000)
        })
    }
  },
  mounted () {
    this.token = this.$route.params.token

    if (typeof this.token !== 'undefined') {
      this.axios.post('/auth/confirmEmail', {
        token: this.token
      })
        .then((response) => {
          this.isVerify = true
          this.$auth.token(null, response.data.access_token)

          this.$auth.watch.data = response.data.data // user object
          VueCookies.set('rememberMe', true)
          this.$auth.watch.authenticated = true
          localStorage.setItem('is_already_connect', 'true')

          this.$salesMachine.accountEnabled()

          let plan = localStorage.getItem('register_plan')
          let goTo
          let user = this.$user

          if (user.isBusiness() || user.isCorporate()) {
            goTo = {name: 'Dashboard'}
          } else if (plan === 'basic' || plan === 'expert' || (user.isBasic() && !plan) || user.isExpert()) {
            if (user.isSe()) {
              goTo = {name: 'SearchSimple'}
            } else {
              goTo = (user.isExpert() && (typeof response.data.data.expert === 'undefined' || !response.data.data.expert.length)) ? {name: 'Profile'} : {name: 'Start'}
            }
          } else {
            goTo = {name: 'Plans'}
          }
          setTimeout(() => {
            this.$router.push(goTo)
          }, 3000)
        })
        .catch((error) => {
          this.isVerify = false
          setTimeout(() => {
            this.$router.push({name: 'Login'})
          }, 5000)
        })
    }
  },
  data () {
    return {
      token: null,
      isVerify: null,
      year: new Date().getFullYear(),
      newActivationLinkAsked: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/EnableAccount.vue